import './App.css';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Contact from './components/routes/contact';
import Movie from './components/routes/movie';
import Home from './components/routes/home';
import SearchResult from './components/movieReturn';
import MovieDetail from './components/movieDetail';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import the CSS styles
import { useEffect } from 'react';


function App() {

    useEffect(() => {
    AOS.init({
      duration: 2500, // values from 0 to 3000, with step 50ms
      once: true, // whether animation should happen only once - while scrolling down
    });
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true, // specifies whether animation should happen only once - while scrolling down
    });
    // This function runs when the component is unmounted
    return () => {
      AOS.refresh();
    };
  }, []);

  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };

  return (
    <div className="App">
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Movie" element={<Movie />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/search" component={SearchResult} />
        <Route path="/movie/:movieId" element={<MovieDetail />} />  
      </Routes>
    </div>

  );
}

export default App;